module.exports = __webpack_public_path__ + "static/swiftlane_face-45fd4f633bc8a170e3d3231b5ba073c4.png";